import axiosRetry from 'axios-retry';
import axios from "axios";

axiosRetry(axios, {retries: 3, retryDelay: (retryCount) => retryCount * 500});
